import { Box, Flex, Grid, Icon, Text, Tooltip } from '@chakra-ui/react';
import { PiFile, PiLink, PiMicrophone, PiVideo } from 'react-icons/pi';

export default function MediaBlocTabHeader({ selectedTab, setSelectedTab }) {
  const mediaTypes = [
    {
      title: 'fileMedia',
      label: 'Fichier',
      tooltip: 'Ajouter un document (moins de 100 Mo)',
      icon: PiFile,
    },
    {
      title: 'linkMedia',
      label: 'Site web',
      tooltip: 'Ajouter un lien vers un site web',
      icon: PiLink,
    },
    {
      title: 'videoMedia',
      label: 'Vidéo',
      tooltip: 'Ajouter un lien vers une vidéo',
      icon: PiVideo,
    },
    {
      title: 'soundMedia',
      label: 'Son',
      tooltip: 'Ajouter un lien vers un fichier audio',
      icon: PiMicrophone,
    },
  ];

  return (
    <Grid templateColumns="repeat(4, 1fr)">
      {mediaTypes.map((tab, index) => (
        <Flex key={index} direction="column" justify="center" gap="0.5rem">
          <Tooltip hasArrow label={tab.tooltip}>
            <Flex
              align="center"
              justify="center"
              cursor="pointer"
              color={selectedTab === tab.title && 'brand.100'}
              fontWeight={selectedTab === tab.title && '600'}
              onClick={() => setSelectedTab(tab.title)}
            >
              <Text display={{ base: 'none', md: 'block' }}>{tab.label}</Text>
              <Icon
                as={tab.icon}
                boxSize="1rem"
                ml={{ base: 0, md: '0.5rem' }}
                mt="0.1rem"
              />
            </Flex>
          </Tooltip>
          <Box
            borderRadius="full"
            height={selectedTab === tab.title ? '.375rem' : '.25rem'}
            background={
              selectedTab === tab.title ? 'tournesol.100' : 'cumulus.10'
            }
          />
        </Flex>
      ))}
    </Grid>
  );
}
